/* template */
<template minapp="mpx" xlang="wxml"><div class="drawer-frame-container"><es-drawer-bottom :show="(open)" :title="(cusTitle)" :defaultNavLeft="(leftTitle)" :customStyle="(containerStyle)" @close="closeDrawer"><div slot="left" class="left-title" v-if="(leftTitle)">{{ title }}<slot name="titleSlot"/></div><slot></slot></es-drawer-bottom></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"m5268b884"}'>
  .left-title
    font-family PingFang SC
    font-size 19px
    font-weight 500
    line-height 23px
    display flex
    align-items center
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m5268b884"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./index.mpx.js?isComponent&outputPath=components%2Findex5268b884%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./index.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Findex5268b884%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m5268b884"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/index5268b884/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-drawer-bottom':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/drawer-bottom/index.mpx?isComponent&outputPath=components%2Findexeb3fdc9e%2Findex"))},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
